"use client";
import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";

import { triggerInfoBarOpened, handleStickyContent } from "@/src/store/stickyInfoBar";

import { infoAddToListing } from "constants/favorite";

import { addListingToFavoriteGroup } from "services/favorites";

import CheckIcon from "assets/svg/radial_check.svg";

import StickyInfoBar from "components/common/sticky-info-bar";

const StickyFavoriteInfoBar = ({ listingId, successCallback, backButtonCondition }) => {
  const dispatch = useDispatch();
  const stickyBarReduxState = useSelector((state) => state.stickyInfoBar.isOpened);
  const stickyBarContentReduxState = useSelector((state) => state.stickyInfoBar.content);
  const lastRemovedFavoriteReduxState = useSelector((state) => state.favorite.lastRemovedGroupInfo);
  const favoriteInfoBarButtonContent = useSelector((state) => state.favorite.favoriteInfoBarButtonContent);

  const handleStickyBackButton = async () => {
    if (backButtonCondition) {
      try {
        const response = await addListingToFavoriteGroup(lastRemovedFavoriteReduxState.id, listingId);
        if (response.status === "success") {
          successCallback && successCallback();
          dispatch(handleStickyContent(infoAddToListing(lastRemovedFavoriteReduxState.title)));
          dispatch(triggerInfoBarOpened());
        }
      } catch (error) {
        console.error(`Error from add item to favorite list: ${error}`);
      }
    }
  };

  return (
    <StickyInfoBar
      isOpened={stickyBarReduxState}
      icon={<CheckIcon />}
      actionText={favoriteInfoBarButtonContent}
      handleActionButton={() => handleStickyBackButton()}
      content={stickyBarContentReduxState}
    />
  );
};

StickyFavoriteInfoBar.propTypes = {
  listingId: PropTypes.number,
  successCallback: PropTypes.func,
  backButtonCondition: PropTypes.bool,
};

export default StickyFavoriteInfoBar;
